import * as yup from 'yup';

import { RenderConfig, Row, SelectInput, TextInput } from 'commons-ui';
import { REFUND_REASON_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	FRESHDESK_TICKET_ID: 'freshdeskTicketId',
	JIRA_TICKET_ID: 'jiraTicketId',
	REFUND_REASON: 'refundReason'
};

export const validationSchema = yup.object().shape({
	freshdeskTicketId: yup.string().required('freshdeskTicketId is a required field'),
	jiraTicketId: yup.string().optional(),
	refundReason: yup.string().required('refundReason is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.FRESHDESK_TICKET_ID]: new RenderConfig()
		.setName('freshdeskTicketId')
		.setLabel('Freshdesk Ticket Id')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.JIRA_TICKET_ID]: new RenderConfig()
		.setName('jiraTicketId')
		.setLabel('Jira Ticket Id')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.REFUND_REASON]: new RenderConfig()
		.setName('refundReason')
		.setLabel('Refund Reason')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: REFUND_REASON_OPTIONS,
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.FRESHDESK_TICKET_ID),
	new Row(FORM_FIELD_KEYS.JIRA_TICKET_ID),
	new Row(FORM_FIELD_KEYS.REFUND_REASON)
];
